import { useTranslation } from "react-i18next";

export default function Prijzen() {
  const { t } = useTranslation("velux-reparatie");
  const rows = t("prijzen.rows", { returnObjects: true }) as Array<{
    service: string;
    price: string;
    time: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("prijzen.h2")}
        </h2>
        <div className="max-w-[800px] mx-auto">
          {/* Mobile: card layout */}
          <div className="md:hidden flex flex-col gap-3">
            {rows.map((row, i) => (
              <div
                key={i}
                className="bg-white rounded-xl border border-brand-border p-4 flex flex-col gap-2"
              >
                <p className="font-geist font-semibold text-sm text-brand-text">
                  {row.service}
                </p>
                <div className="flex items-center justify-between">
                  <span className="font-geist-mono font-bold text-base text-brand-text">
                    {row.price}
                  </span>
                  <span className="font-geist text-sm text-brand-text/60">
                    {row.time}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop: table layout */}
          <div className="hidden md:block border border-brand-border rounded-2xl overflow-hidden">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-brand-yellow">
                  <th className="font-geist-mono font-bold text-sm text-brand-text px-5 py-4 uppercase tracking-wider">
                    Dienst
                  </th>
                  <th className="font-geist-mono font-bold text-sm text-brand-text px-5 py-4 uppercase tracking-wider">
                    Prijs
                  </th>
                  <th className="font-geist-mono font-bold text-sm text-brand-text px-5 py-4 uppercase tracking-wider">
                    Tijd
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className="border-t border-brand-border">
                    <td className="font-geist text-sm text-brand-text px-5 py-4">
                      {row.service}
                    </td>
                    <td className="font-geist-mono font-bold text-sm text-brand-text px-5 py-4">
                      {row.price}
                    </td>
                    <td className="font-geist text-sm text-brand-text/70 px-5 py-4">
                      {row.time}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="font-geist text-sm text-brand-text/60 text-center mt-6">
            {t("prijzen.note")}
          </p>
        </div>
      </div>
    </section>
  );
}